import React from 'react';
import PropTypes from 'prop-types';

import { StyledGridContainer, StyledGridItem } from './style';

export const GridContainer = ({ children, ...rest }) => (
    <StyledGridContainer {...rest} container>
        {children}
    </StyledGridContainer>
);

GridContainer.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};

export const GridItem = ({ children, ...rest }) => {
    return (
        <StyledGridItem {...rest} item container>
            {children}
        </StyledGridItem>
    );
};

GridItem.propTypes = {
    children: PropTypes.any,
    rest: PropTypes.object,
};
